// highcharts.plugin.js
//import Highcharts from 'highcharts'
//import 'highcharts/modules/treemap'
//import {getSVG} from 'highcharts/modules/exporting'
//import 'highcharts/modules/offline-exporting'
const root = document.documentElement;

// 2. Get the computed styles
const styles = getComputedStyle(root);

// 3. Read the specific property
const labelHeader = styles.getPropertyValue('--text-Header').trim();
const surfaceColorDef = styles.getPropertyValue('--surface-color-Default').trim();
const labelColor0 = styles.getPropertyValue('--sei2024-monochromatic-label-color-0').trim();
const labelColor1 = styles.getPropertyValue('--sei2024-monochromatic-label-color-1').trim();
const labelColor2 = styles.getPropertyValue('--sei2024-monochromatic-label-color-2').trim();
const labelColor3 = styles.getPropertyValue('--sei2024-monochromatic-label-color-3').trim();
const labelColor4 = styles.getPropertyValue('--sei2024-monochromatic-label-color-4').trim();
const labelColor5 = styles.getPropertyValue('--sei2024-monochromatic-label-color-5').trim();

export default {
  	install(app, Highcharts) {

    const proto = Highcharts.Exporting.prototype

    // Store the original
    const originalDownloadSVG = proto.downloadSVG

    // Manually replace it
    proto.downloadSVG = function (svg, options) {
		//if(import.meta.env.VITE_APP_DEBUG)
		//  console.log('svgOrig', svg)

		let parser = null
		let svgDoc = null

    	/*** Treemap charts do not recognize label styles, so manually injecting styles ***/
		if(options.chartOptions &&
			options.chartOptions.chart &&
			options.chartOptions.chart.type &&
			options.chartOptions.chart.type == 'treemap') {

			parser = new DOMParser();
			svgDoc = parser.parseFromString(
			svg,
			'image/svg+xml'
			);

			if (import.meta.env.VITE_APP_DEBUG)
				console.log('svg', svgDoc)

			const level1 = svgDoc.querySelectorAll(
			'.indicators-treemap-labels-level-1 .highcharts-data-label-box'
			);
			level1.forEach(lvl => {
				lvl.setAttribute(
					'fill',
					labelHeader
				);
				//required for jpeg/png
				lvl.setAttribute(
					'style',
					'block-size: 26px;'
				);
				//required for pdf
				lvl.setAttribute(
					'height',
					'26'
				);
				let w = Number(lvl.attributes["width"].value) - 4;
				lvl.setAttribute(
					'width',
					w
				);
				//console.log('lvl', lvl)
			})

			// find all treemap labels
			const labels = svgDoc.querySelectorAll(
				'.highcharts-data-label text'
			);

			labels.forEach(label => {
			//console.log('label',label)
			label.setAttribute(
				'style',
				'font-size: 16px!important;font-weight: 400 !important;line-height: 1.5;'
			);

			if(label.parentElement.classList.contains("indicators-treemap-labels-level-1")) {
				let y = Number(label.attributes["y"].value) + 4;
				let x = Number(label.attributes["x"].value) + 2;
				label.setAttribute(
					'x',
					x
				);
				label.setAttribute(
					'y',
					y
				);
				label.setAttribute(
					'fill',
					surfaceColorDef
				);
			} else {
				label.setAttribute(
					'fill',
					getColor(label)
				);
			}
			//console.log('label',label)
			})
		}

		/*** PDFs require some manual styling ***/
		if(options.type == "application/pdf") {

			if(parser == null) {
				parser = new DOMParser();
				svgDoc = parser.parseFromString(
					svg,
					'image/svg+xml'
				)
			}

			//line/bar chart x-axis and category labels not, recognized for PDFs, so manually inject styles
			if(options.chartOptions &&
				options.chartOptions.chart &&
				options.chartOptions.chart.type &&
				(options.chartOptions.chart.type == 'line' || options.chartOptions.chart.type == 'bar' ||
				options.chartOptions.chart.type == 'column')) {

				//highcharts-axis-title
				const axisLbls = svgDoc.querySelectorAll(
				'.highcharts-axis-title'
				);

				//PDF not recognizing Roboto font so use Arial
				axisLbls.forEach(label => {
				//console.log('label',label)
				label.setAttribute(
					'style',
					'font-family: Arial; font-size: 16px;'
				);
				})

				//highcharts-legend-title
				const legendLbls = svgDoc.querySelectorAll(
					'.highcharts-label.highcharts-legend-title text'
				);

				legendLbls.forEach(label => {
				//console.log('label',label)
				label.setAttribute(
					'style',
					'font-family: Arial; font-size: 16px;'
				);
				})

				//Strike though deselected items
				const canvas = document.createElement('canvas');
				const ctx = canvas.getContext('2d');
				ctx.font = '16px Arial';

				svgDoc.querySelectorAll('.highcharts-legend-item-hidden text')
				.forEach(text => {

					const x = Number(text.getAttribute('x'));
					const y = Number(text.getAttribute('y'));

					//const label = text.textContent;
					//const width = label.length * 7;
					//const width = text.getComputedTextLength();
					const width = ctx.measureText(text.textContent).width;

					const strike = svgDoc.createElementNS(
						'http://www.w3.org/2000/svg',
						'path'
					);

					strike.setAttribute(
						'd',
						`M ${x} ${y - 5} L ${x + width} ${y - 5}`
					);

					strike.setAttribute('stroke', 'rgb(44,44,44)');
					strike.setAttribute('stroke-width', '2');
					strike.setAttribute('fill', 'none');

					text.parentNode.insertBefore(strike, text);
				});
			}

			//left align Source and Settings lines in footer for all chart type PDFs
			const captionTextNode = svgDoc.querySelector('.highcharts-caption');
			const tspans = captionTextNode.querySelectorAll('tspan.title');
			const baseX = captionTextNode.getAttribute('x') || '20';

			tspans.forEach(tspan => {
				tspan.setAttribute('x', baseX);
			});
		}

		if(parser == null) {
			return originalDownloadSVG.call(this, svg, options)
		} else {
			svg = new XMLSerializer()
			.serializeToString(svgDoc);

			//if (import.meta.env.VITE_APP_DEBUG)
			//  console.log('newSvg', svg)

			return originalDownloadSVG.call(this, svg, options)
		}
	}

    function getColor(label) {
		const cls = label.children[0]?.classList
		if(cls == null)
			return ''
		else if(cls.contains("indicators-treemap-series-0"))
			return labelColor0;
		else if(cls.contains("indicators-treemap-series-1"))
			return labelColor1;
		else if(cls.contains("indicators-treemap-series-2"))
			return labelColor2;
		else if(cls.contains("indicators-treemap-series-3"))
			return labelColor3;
		else if(cls.contains("indicators-treemap-series-4"))
			return labelColor4;
		else if(cls.contains("indicators-treemap-series-5"))
			return labelColor5;
		else {
		const spanCls = label.querySelector('tspan')?.classList
		if(spanCls != null) {
			if(spanCls.contains("indicators-treemap-series-0"))
				return labelColor0;
			else if(spanCls.contains("indicators-treemap-series-1"))
				return labelColor1;
			else if(spanCls.contains("indicators-treemap-series-2"))
				return labelColor2;
			else if(spanCls.contains("indicators-treemap-series-3"))
				return labelColor3;
			else if(spanCls.contains("indicators-treemap-series-4"))
				return labelColor4;
			else if(spanCls.contains("indicators-treemap-series-5"))
				return labelColor5;
			else
			return "#000"
		} else
			return ''
		}
    }

    // Verify the patch took
    //if (import.meta.env.VITE_APP_DEBUG)
    //  console.log('patched:', proto.downloadSVG !== originalDownloadSVG)
  }
}
